"use client";

import { MapPin, Phone, Mail, Edit } from "lucide-react";
import StepMarker from "./StepMarker";
import { Button } from "./Button";

export default function Step5BusinessSummary({
  formData,
  onBack,
  onDone,
  goToStep,
}) {
  return (
    <div>
      <StepMarker currentStep={5} totalSteps={5} onBack={onBack} />

      <h2 className="text-2xl font-bold mb-1">Review Your Business</h2>
      <p className="text-gray-500 mb-6">
        Take a moment to review your information
      </p>

      {/* Business Details Card */}
      <div className="bg-white border border-gray-200 rounded-lg p-5 mb-6">
        <div className="flex justify-between items-start mb-4">
          <div>
            <h3 className="font-bold text-lg">{formData.businessname}</h3>
            <p className="text-sm text-gray-600 mt-1">
              {formData.businessdescription}
            </p>
          </div>
          <button
            onClick={() => goToStep(1)}
            className="flex items-center text-[#7B189F] hover:text-[#671485]"
          >
            <Edit size={16} className="mr-1" />
            <span className="text-sm">Edit</span>
          </button>
        </div>

        <div className="space-y-2">
          <div className="flex items-center text-sm">
            <Phone size={16} className="text-gray-500 mr-2" />
            <span>{formData.contactphone}</span>
            {formData.contactotherphone && (
              <span className="text-gray-400 ml-2">
                • {formData.contactotherphone}
              </span>
            )}
          </div>

          <div className="flex items-center text-sm">
            <Mail size={16} className="text-gray-500 mr-2" />
            <span>{formData.contactemail}</span>
          </div>

          <div className="flex items-start text-sm">
            <MapPin
              size={16}
              className="text-gray-500 mr-2 mt-0.5 flex-shrink-0"
            />
            <div>
              <div>{formData.businessaddress1}</div>
              {formData.businessaddress2 && (
                <div>{formData.businessaddress2}</div>
              )}
              {formData.businessaddress3 && (
                <div>{formData.businessaddress3}</div>
              )}
              <div>
                {formData.businesscity}, {formData.businessstate}
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Contact Person */}
      <div className="mb-6">
        <div className="flex justify-between items-center mb-2">
          <h3 className="text-xs font-medium text-gray-500 uppercase">
            Contact Person
          </h3>
          <button
            onClick={() => goToStep(1)}
            className="text-gray-400 hover:text-gray-600"
          >
            <Edit size={16} />
          </button>
        </div>
        <div className="bg-white border border-gray-200 rounded-lg p-5">
          <div className="font-medium">{formData.contactperson}</div>
        </div>
      </div>

      {/* Location */}
      {formData.businesslocationmap && (
        <div className="mb-6">
          <div className="flex justify-between items-center mb-2">
            <h3 className="text-xs font-medium text-gray-500 uppercase">
              Business Location
            </h3>
            <button
              onClick={() => goToStep(3)}
              className="text-gray-400 hover:text-gray-600"
            >
              <Edit size={16} />
            </button>
          </div>
          <div className="bg-white border border-gray-200 rounded-lg p-5">
            <div className="text-sm text-gray-600">
              <strong>Address:</strong> {formData.venue}
            </div>
            <div className="text-sm text-gray-600 mt-1">
              <strong>Coordinates:</strong>{" "}
              {formData.businesslocationmap.lat.toFixed(6)},{" "}
              {formData.businesslocationmap.lng.toFixed(6)}
            </div>
          </div>
        </div>
      )}

      {/* Media Files */}
      {(formData.businesscertificate ||
        formData.businessimageurl ||
        formData.businessvideourl) && (
        <div className="mb-6">
          <div className="flex justify-between items-center mb-2">
            <h3 className="text-xs font-medium text-gray-500 uppercase">
              Uploaded Media
            </h3>
            <button
              onClick={() => goToStep(4)}
              className="text-gray-400 hover:text-gray-600"
            >
              <Edit size={16} />
            </button>
          </div>
          <div className="bg-white border border-gray-200 rounded-lg p-5">
            <div className="space-y-2">
              {formData.businesscertificate && (
                <div className="text-sm">
                  <span className="font-medium">Certificate:</span>{" "}
                  {formData.businesscertificate.name}
                </div>
              )}
              {formData.businessimageurl && (
                <div className="text-sm">
                  <span className="font-medium">Image:</span>{" "}
                  {formData.businessimageurl.name}
                </div>
              )}
              {formData.businessvideourl && (
                <div className="text-sm">
                  <span className="font-medium">Video:</span>{" "}
                  {formData.businessvideourl.name}
                </div>
              )}
            </div>
          </div>
        </div>
      )}

      <div className="flex justify-between mt-8">
        <Button variant="outline" onClick={onBack}>
          Back
        </Button>
        <Button
          onClick={onDone}
          className="bg-[#7B189F] hover:bg-[#671485] text-white px-8"
        >
          Submit Business
        </Button>
      </div>
    </div>
  );
}
